import React, { FC } from "react";
import { Grid, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  AddTemplateIcon,
  DataNotAvailableIcon,
} from "../../providers/RexIconsSVG/RexIconsSVG";
import { useI18n } from "../../providers/I18n/I18n";
import Theme from "../../themes/theme";

//changed Button to the material ui import because anchor origin of custom button isn't working in empty state of dataTable

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.UI.white,
    backgroundColor: theme.button.contained.background.primary,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.button.contained.background.hover,
    },
    "@media (height < 650px)": {
      maxHeight: 25,
      fontSize: 10,
    },
  },
  icon: {
    "@media (height < 650px)": {
      maxHeight: 100,
    },
    "@media (height < 600px)": {
      maxHeight: 85,
      paddingTop: 8,
    },
  },
  title: {
    "@media (height < 650px)": {
      fontSize: 16,
    },
  },
  emptyStatePosition: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

interface IEmptyState {
  title?: string;
  emptyTextMessage?: string;
  addDataHandler?: () => void;
  addIcon: boolean;
  addIconTestId?: string;
  hasAddButton?: boolean;
  uploadCsvTitle?: string;
}
const EmptyState: FC<IEmptyState> = ({
  title,
  emptyTextMessage,
  addDataHandler,
  addIcon = true,
  addIconTestId = "",
  hasAddButton = true,
  uploadCsvTitle,
}) => {
  const classes = useStyles();
  const { t } = useI18n();

  const subTitle = () => {
    if (addIcon && hasAddButton) {
      return t("empty_state_helper_text").replace("{title}", title);
    } else if (!hasAddButton && !emptyTextMessage) {
      return t("empty_state_template_text").replace("{title}", title);
    } else if (emptyTextMessage) {
      return emptyTextMessage;
    } else {
      return t("noPendingRequests");
    }
  };  

  return (
    <div className={classes.emptyStatePosition}>
      <Grid container>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          rowSpacing={1}
          style={{ maxHeight: "100%" }}
        >
          <Grid item>
            {addIcon && hasAddButton ? (
              <AddTemplateIcon className={classes.icon} />
            ) : (
              <DataNotAvailableIcon className={classes.icon} />
            )}
          </Grid>
          <Grid item>
            <Typography variant="h4" component="span" className={classes.title}>
              {addIcon && hasAddButton
                ? t("empty_state_not_found").replace("{title}", title)
                : t("empty_state_data_not_found")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="caption">{subTitle()}</Typography>
          </Grid>
          {addIcon && hasAddButton && (
            <Grid item>
              <Button
                className={classes.root}
                disableRipple={true}
                onClick={addDataHandler}
                data-testid={addIconTestId}
              >
                {uploadCsvTitle
                  ? uploadCsvTitle
                  : t("empty_state_button_text").replace("{title}", title)}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default EmptyState;
